const l = {
  name: "PlusCircleFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM11 17H13V13H17V11H13V7H11V11H7V13H11V17Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as PlusCircleFilled
};
